import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { RefinementListProps, useRefinementList } from 'react-instantsearch';
import { FormCheckbox } from '@hvcgroep/design-system';

import gtm from '../../../../helpers/gtm';

import './style.scss';
import Illustration from './Illustration';

export interface SearchFacetRefinementExpandedCheckboxesProps extends RefinementListProps {
  itemClassName?: string;
}

const SearchFacetRefinementExpandedCheckboxes:
React.FC<SearchFacetRefinementExpandedCheckboxesProps> = (props) => {
  const { t } = useTranslation();

  const {
    attribute,
    itemClassName,
  } = props;

  const {
    items,
    canRefine,
    refine,
  } = useRefinementList(props);

  const itemClassNames = c('Searchkit__Facet__RefinementExpandedCheckboxes__item col-xl-3 col-lg-6 col-12', itemClassName);

  const fieldName = `refinementList_${attribute}`;

  const options = items.map((item) => ({
    value: item.value,
    checked: item.isRefined,
    label: (
      <span className="Searchkit__Facet__label" data-facet-label={item.label} data-facet-count={item.count}>
        <Illustration label={item.value} className="Searchkit__Facet__label__illustration" />
        <div className="Searchkit__Facet__label__text">
          <p className="Searchkit__Facet__label__title mb-0">{item.value.split('|')[0]}</p>
          <p className="Searchkit__Facet__label__subtitle mb-0 text-small">{item.value.split('|')[1]}</p>
        </div>
      </span>
    ),
    disabled: item.count === 0,
  }));

  if (!canRefine) {
    return null;
  }

  return (
    <div className="u-small-gutter-width o-vertical-bootstrap-gutter">
      <div className="Searchkit__Facet__RefinementExpandedCheckboxes__wrapper row">
        {options.map((option) => (
          <FormCheckbox
            label={option.label}
            name={`${fieldName}--${option.value}`}
            checked={option.checked}
            expanded
            className={itemClassNames}
            visualValidation={false}
            verticalSpacing={false}
            onChange={(e) => {
              // @ts-expect-error
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              gtm.trackUserEvent(`vacancies-filter-${attribute}`, option.value, e.target.checked ? 'add' : 'remove');

              refine(e.target.name.split('--')[1]!);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchFacetRefinementExpandedCheckboxes;
